export default "__VITE_ASSET__5f23c536__"